<template>
  <div class="delete-dialog">
    <FormDialog
        :value="true"
        no-fullscreen
        :toolbar-title="title"
        :max-width="maxWidth"
        :button-submit-name="buttonTitle"
        @save="borrarRegistro()"
        :disabled="borrando"
        :no-button="true"
        @close="$emit('cancel')"
    >
      <template slot="form">
        <p>{{text}}</p>
      </template>
    </FormDialog>
    <InfoSnackbar :snackbar="snackbar"></InfoSnackbar>
  </div>
</template>

<script>

  import InfoSnackbar from "./utils/InfoSnackbar";
  import FormDialog from "./FormDialog";
  import deleteRegistroMixin from "../mixins/crud-mixins/deleteRegistroMixin";
  import snackbarMixin from "../mixins/snackbarMixin";

  export default {
    name: "DeleteDocumento",
    components: {InfoSnackbar, FormDialog},
    mixins: [deleteRegistroMixin, snackbarMixin, ],
    props: {
      baseUrl: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        default: () => 'Eliminar',
      },
      text: {
        type: String,
        default: () => 'Está seguro que desea eliminar el registro?',
      },
      maxWidth: {
        type: String,
        default: () => '360',
      },
      buttonTitle: {
        type: String,
        default: () => 'Eliminar',
      },
    },
    methods: {
      onBorradoExitoso() {
        return this.$emit('close');
      },
    }
  }
</script>

<style scoped>

</style>
